import { render } from "./PDFNav.vue?vue&type=template&id=17a43667"
import script from "./PDFNav.vue?vue&type=script&lang=js"
export * from "./PDFNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__